<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 10.2222C9.2273 10.2222 10.2222 9.2273 10.2222 8C10.2222 6.7727 9.2273 5.77778 8 5.77778C6.7727 5.77778 5.77778 6.7727 5.77778 8C5.77778 9.2273 6.7727 10.2222 8 10.2222ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.99826 0C8.48918 0 8.88715 0.397969 8.88715 0.888889V1.77778C8.88715 2.2687 8.48918 2.66667 7.99826 2.66667C7.50734 2.66667 7.10938 2.2687 7.10938 1.77778V0.888889C7.10938 0.397969 7.50734 0 7.99826 0Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.99826 13.3335C8.48918 13.3335 8.88715 13.7315 8.88715 14.2224V15.1113C8.88715 15.6022 8.48918 16.0002 7.99826 16.0002C7.50734 16.0002 7.10938 15.6022 7.10938 15.1113V14.2224C7.10938 13.7315 7.50734 13.3335 7.99826 13.3335Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 8.00022C16 8.49114 15.602 8.88911 15.1111 8.88911L14.2222 8.88911C13.7313 8.88911 13.3333 8.49114 13.3333 8.00022C13.3333 7.5093 13.7313 7.11133 14.2222 7.11133L15.1111 7.11133C15.602 7.11133 16 7.5093 16 8.00022Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.66797 8.00022C2.66797 8.49114 2.27 8.88911 1.77908 8.88911L0.890191 8.88911C0.399271 8.88911 0.00130194 8.49114 0.00130197 8.00022C0.00130199 7.5093 0.399271 7.11133 0.890191 7.11133L1.77908 7.11133C2.27 7.11133 2.66797 7.5093 2.66797 8.00022Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5166 2.48252C13.8637 2.82965 13.8637 3.39246 13.5166 3.7396L13.0721 4.18404C12.725 4.53117 12.1622 4.53117 11.815 4.18404C11.4679 3.83691 11.4679 3.27409 11.815 2.92696L12.2595 2.48252C12.6066 2.13538 13.1694 2.13538 13.5166 2.48252Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.48301 2.48252C2.83014 2.13538 3.39295 2.13538 3.74008 2.48252L4.18453 2.92696C4.53166 3.27409 4.53166 3.83691 4.18453 4.18404C3.8374 4.53117 3.27458 4.53117 2.92745 4.18404L2.48301 3.7396C2.13587 3.39246 2.13587 2.82965 2.48301 2.48252Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.815 11.816C12.1622 11.4689 12.725 11.4689 13.0721 11.816L13.5166 12.2605C13.8637 12.6076 13.8637 13.1704 13.5166 13.5175C13.1694 13.8647 12.6066 13.8647 12.2595 13.5175L11.815 13.0731C11.4679 12.726 11.4679 12.1631 11.815 11.816Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.18453 11.816C4.53166 12.1631 4.53166 12.726 4.18453 13.0731L3.74008 13.5175C3.39295 13.8647 2.83014 13.8647 2.48301 13.5175C2.13587 13.1704 2.13587 12.6076 2.48301 12.2605L2.92745 11.816C3.27458 11.4689 3.8374 11.4689 4.18453 11.816Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconSun",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "16"
    }
  }
};
</script>
